/**
 * Comprehensive error handling utilities
 */

/**
 * Handle and log errors with context
 */
export const handleError = (error, context = '') => {
  const errorInfo = {
    message: error.message || 'An unknown error occurred',
    context,
    stack: error.stack,
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent,
    url: window.location.href
  };

  // Log to console in development
  if (import.meta.env.DEV) {
    console.error('Error:', errorInfo);
  }

  // In production, you could send to error tracking service
  // Example: Sentry, LogRocket, etc.
  
  return errorInfo;
};

/**
 * Retry function with exponential backoff
 */
export const retryWithBackoff = async (fn, maxRetries = 3, initialDelay = 1000) => {
  let lastError;
  
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      if (i < maxRetries - 1) {
        const delay = initialDelay * Math.pow(2, i);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }
  
  throw lastError;
};

/**
 * Safe async wrapper
 */
export const safeAsync = async (asyncFn, fallback = null) => {
  try {
    return await asyncFn();
  } catch (error) {
    handleError(error, 'safeAsync');
    return fallback;
  }
};

/**
 * Debounced error handler
 */
export const debounceError = (() => {
  let errorTimeout;
  const errors = [];
  
  return (error, callback) => {
    errors.push(error);
    
    clearTimeout(errorTimeout);
    errorTimeout = setTimeout(() => {
      callback(errors);
      errors.length = 0;
    }, 1000);
  };
})();















